<template lang="pug">
#img-viewer
  ImageViewer(v-if="show" :z-index="zIndex" :initial-index="index" :on-close="closeImgHandler" :imgsList="imgsList" )
</template>
<script>
import ImageViewer from "./image-viewer.vue";
export default {
  components: { ImageViewer },
  props: {
    index: { default: 0, type: Number },
    zIndex: { default: 0, type: Number },
    imgsList: { default: () => [], type: Array },
    onClose: { default: undefined, type: [Function, undefined] }
  },
  data() {
    return { show: true };
  },
  methods: {
    closeImgHandler() {
      const { resolve, onClose, urlList } = this;
      this.show = false;
      if (onClose) onClose(urlList);
      this.$nextTick(() => {
        resolve();
        this.$destroy();
      });
    }
  }
};
</script>
